/**
 * @name useOperadorContext
 * @description Hook para usar o contexto do operador
 * @author Keven Adan Bezerra | kevenadanb
 * @package src/contexts/OperadorContext/useOperadorContext.ts
 */

import { useContext } from "react";
import OperadorContext, { OperadorContextType } from "./OperadorContext";

export const useOperadorContext = (): OperadorContextType => {
  const context = useContext(OperadorContext);
  if (!context) {
    throw new Error(
      "useOperadorContext deve ser usado dentro de um OperadorProvider",
    );
  }
  return context;
};

export default useOperadorContext;
